module.exports = __webpack_public_path__ + "img/image15@3x.5371b8ef.png";